import QRCode from "qrcode";
import { useState, useEffect } from "react";
const QRCodeGenerator = ({ dataString }) => {
    const [qrImage, setQrImage] = useState(null);

    const generateQRCode = async () => {
        try {
            const qrCodeData = dataString;
            const qrCodeImage = await QRCode.toDataURL(qrCodeData);
            setQrImage(qrCodeImage);
        } catch (error) {
            console.error("Error generating QR code:", error);
        }
    }

    useEffect(() => {
        generateQRCode();
        console.log(dataString)
    }, [dataString]);

  return (
    <div className="w-full flex justify-center items-center">
      {qrImage && <img src={qrImage} width="300" alt="QR" />}
    </div>
  );
}

export default QRCodeGenerator;